// extracted by mini-css-extract-plugin
export default {"root":"LatestLoans_root__NhZ88","header":"LatestLoans_header__WvANZ","dealContainer":"LatestLoans_dealContainer__SpXSf","showMoreButton":"LatestLoans_showMoreButton__My4LV"};